import { ofType } from "redux-observable";
import { mergeMap } from "rxjs/operators";
import { merge, of } from "rxjs";
// import { push } from 'connected-react-router';

import { CREATE_WATCH_LIST_ENTRY } from "../types";
import {
  createWatchListEntryFulfilled,
  createWatchListEntryPending,
  createWatchListEntryRejected,
} from "../actions";
import { sendApiRequest } from "../../../actions/apiRequestActions";
import { notifyError, notifySuccess } from "../../../actions";
import { WATCH_LIST_ENTRY_MESSAGES } from "../constants/watchListEntryMessages";
// import routesConfig from '../../../routes/routes-config';
import generateError from "../../../utilities/generateError";

const createPayload = (payload) => ({
  method: "post",
  url: "watchlistentry/create",
  onSuccess: [
    createWatchListEntryFulfilled,
    () => notifySuccess(WATCH_LIST_ENTRY_MESSAGES.CREATED),
    // () => push(routesConfig.watchListEntriesByWatchListPage.path),
  ],
  onError: [
    createWatchListEntryRejected,
    (error) => notifyError(generateError(error)),
  ],
  data: payload,
});

const meta = {
  api: "ajaxApi",
};

const createWatchListEntryEpic$ = (action$) =>
  action$.pipe(
    ofType(CREATE_WATCH_LIST_ENTRY.DEFAULT),
    mergeMap(({ payload }) =>
      merge(
        of(createWatchListEntryPending()),
        of(sendApiRequest(createPayload(payload), meta))
      )
    )
  );

export default createWatchListEntryEpic$;



// WEBPACK FOOTER //
// ./src/features/watch-list-entry/epics/createWatchListEntryEpic.js